import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rootRoute } from './__root';
import { profileKeys } from '@/features/settings/queries';
import { templatesSearchSchema } from '@/features/settings/templates/search-schema';
import { TemplatesPendingState } from '@/features/settings/templates/TemplatesPendingState';
import { getProfile } from '@/lib/profile';
import { requireAuth } from '@/lib/route-guards';

/**
 * `/templates` — moved out of `/settings?section=templates` onto the main
 * sidebar (day-to-day work, not configuration). `templateCollectionId` is
 * this route's own search param now (`./search-schema.ts`) rather than
 * riding on `/settings`'s.
 */
export const templatesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/templates',
  validateSearch: templatesSearchSchema,
  beforeLoad: requireAuth,
  loader: async ({ context: { queryClient } }) => {
    await queryClient
      .ensureQueryData({ queryKey: profileKeys.current(), queryFn: getProfile })
      .catch(() => undefined);
  },
  pendingComponent: TemplatesPendingState,
  pendingMs: 0,
  pendingMinMs: 0,
  component: lazyRouteComponent(
    () => import('@/features/settings/templates/TemplatesPage'),
    'TemplatesPage',
  ),
});
